export default __webpack_public_path__ + "static/media/Ravi_Teja_Alchuri_CV.a4699fd9.pdf";